import { useContext } from 'react';

import MessageContext from './MessageContext';
import { useQuery as useQueryOriginal } from './useQuery';

export const useQueryGrid = (queryKey, queryFn, options) => {
  const { showErrorMessage } = useContext(MessageContext);
  return useQueryOriginal(queryKey, queryFn, {
    onError: (e) => showErrorMessage(e?.message),
    ...options,
  });
};
